__turbopack_context__.v({
  "details": "Z2anNa_details",
  "summary": "Z2anNa_summary",
});
